

// Get All Actions
export const getActionsEnvoisStart = ()=>({
    type: 'GET_ACTIONS_ENVOIS_START',
})
export const getActionsEnvoisSuccess = (actionsEnvois)=>({
    type: 'GET_ACTIONS_ENVOIS_SUCCESS',
    payload: actionsEnvois
})
export const getActionsEnvoisFailure = (error)=>({
    type: 'GET_ACTIONS_ENVOIS_FAILURE',
    payload: error
})

// Add one action
export const addActionEnvoieStart =()=>({
    type: "ADD_ACTION_ENVOIE_START",
});
export const addActionEnvoieSuccess =(actionEnvoie)=>({
    type: "ADD_ACTION_ENVOIE_SUCCESS",
    payload: actionEnvoie,
});
export const addActionEnvoieFailure =(error)=>({
    type: "ADD_ACTION_ENVOIE_FAILURE",
    payload: error,
});

// Update one action
export const updateActionEnvoieStart =()=>({
    type: "UPDATE_ACTION_ENVOIE_START",
});
export const updateActionEnvoieSuccess =(actionEnvoie)=>({
    type: "UPDATE_ACTION_ENVOIE_SUCCESS",
    payload: actionEnvoie,
});
export const updateActionEnvoieFailure =(error)=>({
    type: "UPDATE_ACTION_ENVOIE_FAILURE",
    payload: error,
});
